// Mock data para GRUPO PINACSA Landing Page

export const companyInfo = {
  name: "GRUPO PINACSA",
  tagline: "Todo lo que tu empresa necesita, en un solo proveedor.",
  subtitle: "Suministros, mantenimiento y tecnología para impulsar tu operación.",
  contact: {
    address: "MONTIJO #1428 ALTARIA RESIDENCIAL APODACA N.L.",
    phone: "8126288221",
    email: "grupopinacsa@gmail.com",
    whatsapp: "https://wa.me/message/ITBOM5CJGNGQO1",
    whatsappNumber: "8126288221",
    hours: "Lunes a Viernes 8:00 AM - 6:00 PM"
  }
};

export const services = [
  {
    id: 1,
    title: "Renta, venta y maniobras con montacargas",
    description: "Servicios completos de montacargas industriales: renta, venta y maniobras especializadas para almacenes e industria.",
    icon: "Truck",
    image: "https://images.unsplash.com/photo-1564182843062-67664a64c9b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxmb3JrbGlmdCUyMGluZHVzdHJpYWx8ZW58MHx8fHwxNzU5ODQyNjQ2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Ferretería en general, eléctrico y plomería",
    description: "Materiales y equipos para instalaciones eléctricas, hidráulicas y mantenimiento industrial.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1553873002-785d775854c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwdG9vbHN8ZW58MHx8fHwxNzU5Nzg2NjIwfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Maquinaria y herramientas industriales",
    description: "Equipos de alto rendimiento para construcción, reparación y manufactura.",
    icon: "Settings",
    image: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZXF1aXBtZW50fGVufDB8fHx8MTc1OTc4NjYxMHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Productos de limpieza",
    description: "Insumos para oficinas, hoteles, y plantas industriales.",
    icon: "SprayCan",
    image: "https://images.unsplash.com/photo-1626379481874-3dc5678fa8ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxjbGVhbmluZyUyMHN1cHBsaWVzfGVufDB8fHx8MTc1OTg0MjY4Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    title: "Equipos de cómputo y digitales",
    description: "Laptops, PCs, impresoras, monitores, accesorios y periféricos.",
    icon: "Monitor",
    image: "https://images.unsplash.com/photo-1711397544921-98cbc9042ab8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHx0ZWNobm9sb2d5JTIwc2VydmljZXN8ZW58MHx8fHwxNzU5Nzg2NjE1fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    title: "Consumibles y accesorios",
    description: "Cartuchos, toners, cables, memorias, adaptadores y componentes de red.",
    icon: "HardDrive",
    image: "https://images.unsplash.com/photo-1706895040634-62055892cbbb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxwcmludGVyJTIwY2FydHJpZGdlfGVufDB8fHx8MTc1OTg0MjY5NXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 7,
    title: "Soluciones IT y de oficina",
    description: "Servidores, licencias de software, infraestructura de red, cámaras, puntos de acceso, UPS, routers, mantenimiento tecnológico y soporte empresarial.",
    icon: "Server",
    image: "https://images.unsplash.com/photo-1740863775545-fa0b13ad4095?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHx0ZWNobm9sb2d5JTIwc2VydmljZXN8ZW58MHx8fHwxNzU5Nzg2NjE1fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 8,
    title: "Aire acondicionado",
    description: "Venta, instalación, reparación y mantenimiento de sistemas de climatización.",
    icon: "Snowflake",
    image: "https://images.unsplash.com/photo-1545259741-2ea3ebf61fa3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxhaXIlMjBjb25kaXRpb25pbmd8ZW58MHx8fHwxNzU5ODQyNzAxfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 9,
    title: "Refrigeración en general y mantenimiento",
    description: "Equipos comerciales e industriales, cámaras frías, chillers, etc.",
    icon: "Thermometer",
    image: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwZXF1aXBtZW50fGVufDB8fHx8MTc1OTc4NjYxMHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 10,
    title: "Artículos publicitarios",
    description: "Promocionales, uniformes, bordados, grabados y productos personalizados para empresas.",
    icon: "Megaphone",
    image: "https://images.unsplash.com/photo-1590451340757-99b7215aad71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwcm9tb3Rpb25hbCUyMGl0ZW1zfGVufDB8fHx8MTc1OTg0MjcwNnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 11,
    title: "Artículos de oficina y papelería",
    description: "Desde suministros básicos hasta soluciones integrales de oficina.",
    icon: "FileText",
    image: "https://images.unsplash.com/photo-1456735190827-d1262f71b8a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBzdGF0aW9uZXJ5fGVufDB8fHx8MTc1OTg0Mjc0N3ww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 12,
    title: "Mantenimientos, construcciones y remodelaciones",
    description: "Obras, acabados, remodelaciones corporativas e instalaciones técnicas.",
    icon: "Building",
    image: "https://images.pexels.com/photos/7937687/pexels-photo-7937687.jpeg"
  }
];

export const benefits = [
  {
    title: "Experiencia multidisciplinaria",
    description: "Más de 15 años brindando soluciones integrales",
    icon: "Award"
  },
  {
    title: "Entregas rápidas a nivel nacional",
    description: "Cobertura en todo México con tiempos optimizados",
    icon: "Truck"
  },
  {
    title: "Asesoría técnica especializada",
    description: "Equipo de expertos para cada área de servicio",
    icon: "Users"
  },
  {
    title: "Soluciones personalizadas",
    description: "Adaptamos nuestros servicios a cada industria",
    icon: "Settings"
  },
  {
    title: "Cobertura integral",
    description: "Mantenimiento, suministros y tecnología en un solo lugar",
    icon: "Shield"
  }
];

export const sectors = [
  "Hotelero",
  "Industrial", 
  "Corporativo",
  "Educativo",
  "Comercial",
  "Gubernamental"
];

export const heroImage = "https://images.pexels.com/photos/8482832/pexels-photo-8482832.jpeg";

// Mock function removed - now using real backend API